module.exports = __webpack_public_path__ + "fonts/SamsungOne-300C_v1.1.9233a4a8.ttf";